import React, {useEffect, useState} from "react"
import loaderLogo from "../../assets/icons/loading/loader_logo.svg"
import {LOADING_TEXT} from "../../utils/Contants";
import styles from "../../assets/styles/Loader.module.css"

const Loader: React.FC = () => {
    const [showComponent, setShowComponent] = useState(false)

    useEffect(() => {
        const delay = setTimeout(() => {
            setShowComponent(true)
        }, 50)
        return () => {
            clearTimeout(delay)
        }
    }, [])

    return (
        <div className={showComponent ? styles.loader : styles.loaderstyles + " " + styles.loaderStarting}>
            <div className={styles.loaderImg}>
                <img src={loaderLogo} alt={LOADING_TEXT} width={95} height={95}/>
            </div>
        </div>
    )
}
export default Loader
